<div class="user-avatar {{getRandomColor()}}" [style.width.px]="size" [style.height.px]="size">{{userNameInicials()}}</div>
